import { LegacyDevice } from 'console/device/device';
import { generateMongoDBId } from 'console/utils/mongo-db';
export const getDeviceName = (devices) => Object.fromEntries(devices.map((dev) => [dev.id, LegacyDevice.display_name(dev)]));
export const deviceTreeWithId = (device_tree) => {
    const result = [];
    if (device_tree) {
        for (const node of device_tree) {
            if ('Children' in node) {
                result.push({
                    ...node,
                    id: generateMongoDBId(),
                    Children: deviceTreeWithId(node.Children),
                });
                continue;
            }
            result.push(node);
        }
    }
    return result;
};
